/*
 * @Author: cc
 * @LastEditTime: 2023-11-01 13:44:27
 */
import {
  advertisementDataProps,
  InitAdvertisementData,
} from "@root/actions/index";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
const initialState: advertisementDataProps = InitAdvertisementData;

export const advertisementSlice = createSlice({
  name: "advertisementData",
  initialState,
  reducers: {
    setAdvertisementData: (
      state,
      action: PayloadAction<advertisementDataProps>
    ) => {
      state = action.payload;
      return state;
    },
  },
});

// Action creators are generated for each case reducer function
const { actions, reducer } = advertisementSlice;
export const { setAdvertisementData } = actions;
export default reducer;
